import React, { Component } from 'react'
import '../index.scss'
import { Link } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Row, Col, Form, Input, Spin } from 'antd'

import BarangayLogo from '../../../components/Custom/BarangayLogo'
import BarangayNameAnimated from '../../../components/Custom/BarangayNameAnimated'

class Index extends Component {

	constructor(props) {
		super(props)

		this.state = {
		}

		this.handleOnSubmit = this.handleOnSubmit.bind(this)
	}

	componentDidMount() {
		var elemBody = document.querySelector('body')
		elemBody.style.background = '#eceffd'

		var elemRoot = document.getElementById('root')
		elemRoot.style.background = 'none'
	}

	handleOnSubmit(e) {
		e.preventDefault()
		const { form, AuthStore } = this.props

		form.validateFields((err, values) => {
			if (err) {
				AuthStore.setError(new Error('Please Fill All Fields'))
				return false
			}
			const { username, password } = values
			console.log('login values', values)
			AuthStore.authenticate(username, password)
		})
	}

	render() {
		const { AuthStore, form } = this.props
		const { authenticating, error } = AuthStore
		const { getFieldDecorator, resetFields } = form

		return (
			<div>
				<Row type='flex' justify='center' style={{ paddingTop: 20 }}>
					<BarangayNameAnimated />
				</Row>
				<Row type='flex' justify='center'>
					<Col md={10} sm={24}>
						<div className="card" style={{ marginRight: 30 }}>
							<div className="card-body">
								<h4 className="header-title mb-3">Login to your account</h4>

								<Row type='flex' justify='center'>
									<BarangayLogo
										width={250}
										height='auto'
										alt='brgy-logo'
										style={{ marginTop: 7 }}
									/>
								</Row>

								<Form onSubmit={this.handleOnSubmit}>
									<div className="form-group mb-3">
										<label htmlFor="emailaddress">Username</label>
										<Form.Item>
											{ getFieldDecorator('username', {
												rules: [{
													required: true,
													message: 'Username is required.'
												}]
											})
											(
												<Input placeholder='Enter your username'/>
											)}
										</Form.Item>
									</div>

									<div className="form-group mb-3">
										<label htmlFor="password">Password</label>
										<Form.Item>
											{ getFieldDecorator('password', {
												rules: [{
													required: true,
													message: 'Password is required.'
												}]
											})
											(
												<Input.Password placeholder='Enter your password' />
											)}
										</Form.Item>
									</div>

									{
										authenticating &&
										<Row type='flex' justify='center'>
											<Spin />
										</Row>
									}

									{
										error &&
									<div style={{ marginTop: '20px' }} className="alert alert-danger alert-dismissible fade show" role="alert">
										<i className="mdi mdi-block-helper mr-2"></i>
										{error.message}
										<button onClick={() => {
											AuthStore.setError(null)
											resetFields()
										}} type="button" className="close" data-dismiss="alert" aria-label="Close">
											<span aria-hidden="true">×</span>
										</button>
									</div>
									}

									<div className="form-group text-center mb-3">
										<button className="btn btn-primary btn-lg width-lg btn-rounded" type="buttom" onClick={this.handleOnSubmit}> Sign In </button>
									</div>

								</Form>

								<div className="mt-5 text-center">
		  							<img src='/assets/images/poweredbyLogo.png' width='220' height='auto' alt='Vibe Technologies'/>
		 						</div>
							 	<div className="mt-2 text-center">
		 							<i>VERSION: <span>{process.env.REACT_APP_DEV_VERSION}</span></i>
		 						</div>
							</div>
						</div>
					</Col>
				</Row>
			</div>
		)
	}
}

const composed = compose(
	Form.create({ name: 'login-form' }),
	inject('AuthStore'),
	observer,
)

export default composed(Index)
